"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTaxesFromBasket = exports.getShippingMethodsForShipment = exports.getPriceBooksForBasket = exports.getPaymentMethodsForBasket = exports.getBasket = void 0;
var _commerceSdkIsomorphic = require("commerce-sdk-isomorphic");
var _utils = require("../utils");
/*
 * Copyright (c) 2023, Salesforce, Inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

// We must use a client with no parameters in order to have required/optional match the API spec

// This is defined here, rather than `types.ts`, because it relies on `Client` and `QueryKeys`,
// and making those generic would add too much complexity.

const getBasket = exports.getBasket = {
  path: params => ['/commerce-sdk-react', '/organizations/', params.organizationId, '/baskets/', params.basketId],
  queryKey: params => {
    return [...getBasket.path(params), (0, _utils.pickValidParams)(params, _commerceSdkIsomorphic.ShopperBaskets.paramKeys.getBasket)];
  }
};
const getPaymentMethodsForBasket = exports.getPaymentMethodsForBasket = {
  path: params => ['/commerce-sdk-react', '/organizations/', params.organizationId, '/baskets/', params.basketId, '/payment-methods'],
  queryKey: params => {
    return [...getPaymentMethodsForBasket.path(params), (0, _utils.pickValidParams)(params, _commerceSdkIsomorphic.ShopperBaskets.paramKeys.getPaymentMethodsForBasket)];
  }
};
const getPriceBooksForBasket = exports.getPriceBooksForBasket = {
  path: params => ['/commerce-sdk-react', '/organizations/', params.organizationId, '/baskets/', params.basketId, '/price-books'],
  queryKey: params => {
    return [...getPriceBooksForBasket.path(params), (0, _utils.pickValidParams)(params, _commerceSdkIsomorphic.ShopperBaskets.paramKeys.getPriceBooksForBasket)];
  }
};
const getShippingMethodsForShipment = exports.getShippingMethodsForShipment = {
  path: params => ['/commerce-sdk-react', '/organizations/', params.organizationId, '/baskets/', params.basketId, '/shipments/', params.shipmentId, '/shipping-methods'],
  queryKey: params => {
    return [...getShippingMethodsForShipment.path(params), (0, _utils.pickValidParams)(params, _commerceSdkIsomorphic.ShopperBaskets.paramKeys.getShippingMethodsForShipment)];
  }
};
const getTaxesFromBasket = exports.getTaxesFromBasket = {
  path: params => ['/commerce-sdk-react', '/organizations/', params.organizationId, '/baskets/', params.basketId, '/taxes'],
  queryKey: params => {
    return [...getTaxesFromBasket.path(params), (0, _utils.pickValidParams)(params, _commerceSdkIsomorphic.ShopperBaskets.paramKeys.getTaxesFromBasket)];
  }
};